import { normaliseViewLanguage } from './viewLanguages.js';

// Editorial labels use the View language and remain independent of generated headings.
const AFTERWORD = {
  en: 'Afterword', 'zh-CN': '结语', 'zh-TW': '結語', ja: 'あとがき', ko: '맺음말',
  fr: 'Postface', de: 'Nachwort', es: 'Epílogo', it: 'Postfazione', pt: 'Posfácio',
  ar: 'خاتمة', hi: 'उपसंहार', ru: 'Послесловие', uk: 'Післямова', nl: 'Nawoord',
  pl: 'Posłowie', sv: 'Efterord', da: 'Efterord', no: 'Etterord', nb: 'Etterord',
  nn: 'Etterord', fi: 'Jälkisanat', el: 'Επίλογος', tr: 'Sonsöz', vi: 'Lời kết',
  th: 'บทส่งท้าย', id: 'Penutup', ms: 'Penutup', he: 'אחרית דבר', fa: 'سخن پایانی',
  bn: 'উপসংহার', ta: 'முடிவுரை', ur: 'اختتامی کلمات', cs: 'Doslov', sk: 'Doslov',
  ro: 'Postfață', hu: 'Utószó', bg: 'Послеслов', hr: 'Pogovor', sl: 'Spremna beseda',
  sr: 'Поговор', 'sr-Latn': 'Pogovor', et: 'Järelsõna', lv: 'Pēcvārds', lt: 'Pabaigos žodis',
  ca: 'Epíleg', eu: 'Azken hitza', gl: 'Epílogo', is: 'Eftirmáli', af: 'Nawoord',
};

const FURTHER_READING = {
  en: 'Further reading', 'zh-CN': '延伸阅读', 'zh-TW': '延伸閱讀', ja: '関連資料', ko: '더 읽을거리',
  fr: 'Pour aller plus loin', de: 'Weiterführende Lektüre', es: 'Lecturas complementarias',
  it: 'Approfondimenti', pt: 'Leituras complementares', ar: 'للقراءة الموسعة', hi: 'आगे पढ़ें',
  ru: 'Дополнительное чтение', uk: 'Додаткове читання', nl: 'Verder lezen', pl: 'Dalsza lektura',
  sv: 'Vidare läsning', da: 'Videre læsning', no: 'Videre lesning', nb: 'Videre lesning',
  nn: 'Vidare lesing', fi: 'Lisälukemista', el: 'Περαιτέρω ανάγνωση', tr: 'İleri okumalar',
  vi: 'Đọc thêm', th: 'อ่านเพิ่มเติม', id: 'Bacaan lanjutan', ms: 'Bacaan lanjut',
  he: 'לקריאה נוספת', fa: 'برای مطالعه بیشتر', bn: 'আরও পড়ুন', ta: 'மேலும் வாசிக்க',
  ur: 'مزید مطالعہ', cs: 'Další četba', sk: 'Ďalšie čítanie', ro: 'Lecturi suplimentare',
  hu: 'További olvasmányok', bg: 'Допълнително четене', hr: 'Daljnje čitanje', sl: 'Nadaljnje branje',
  sr: 'Додатна литература', 'sr-Latn': 'Dodatna literatura', et: 'Lisalugemist',
  lv: 'Papildu lasāmviela', lt: 'Papildoma literatūra', ca: 'Lectures complementàries',
  eu: 'Irakurgai osagarriak', gl: 'Lecturas complementarias', is: 'Frekari lestur', af: 'Verdere leeswerk',
};

function editorialLabel(labels, language, text, translatedFallback = '') {
  let code = normaliseViewLanguage(language);
  if (!code) {
    // Saved CJK text supplies an interim label while source-language detection loads.
    code = /[\u3040-\u30ff]/u.test(text) ? 'ja' : /[\uac00-\ud7af]/u.test(text) ? 'ko'
      : /[\u3400-\u9fff]/u.test(text) ? 'zh-CN' : 'en';
  }
  return labels[code] || labels[code.split('-')[0]] || translatedFallback || labels.en;
}

export function viewClosingLabel(language, text = '', translatedFallback = '') {
  return editorialLabel(AFTERWORD, language, text, translatedFallback);
}

export function viewFurtherReadingLabel(language, text = '') {
  return editorialLabel(FURTHER_READING, language, text);
}
